import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE_URL = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000,
});

// Response interceptor for error handling
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const errorMessage = error.response?.data?.error?.message || error.message || 'Something went wrong';
    console.error('API Error:', errorMessage);
    return Promise.reject(new Error(errorMessage));
  }
);

// Features API
export const featuresAPI = {
  getAll: () => apiClient.get('/features'),
  create: (data) => apiClient.post('/features', data),
  getById: (id) => apiClient.get(`/features/${id}`),
};

// Reviews API
export const reviewsAPI = {
  getAll: () => apiClient.get('/reviews'),
  create: (data) => apiClient.post('/reviews', data),
  approve: (id) => apiClient.patch(`/reviews/${id}/approve`),
};

// Appointments API
export const appointmentsAPI = {
  getAll: (params) => apiClient.get('/appointments', { params }),
  create: (data) => apiClient.post('/appointments', data),
  getById: (id) => apiClient.get(`/appointments/${id}`),
  update: (id, data) => apiClient.patch(`/appointments/${id}`, data),
};

// Contact API
export const contactAPI = {
  submit: (data) => apiClient.post('/contact', data),
  getAll: () => apiClient.get('/contact'),
};

export default apiClient;
